import { announceToScreenReader } from '@/utils/accessibility'
import { Box } from '@mui/material'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

interface RouteAnnouncerProps {
  children: React.ReactNode
}

export const RouteAnnouncer = ({ children }: RouteAnnouncerProps) => {
  const location = useLocation()
  const previousPath = useRef(location.pathname)

  useEffect(() => {
    if (previousPath.current !== location.pathname) {
      const pathSegments = location.pathname.split('/').filter(Boolean)
      const pageName = pathSegments[pathSegments.length - 1] || 'Home'
      const formattedPageName = pageName
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')

      announceToScreenReader(`Navigated to ${formattedPageName} page`, 'polite')

      document.title = `${formattedPageName} - Customer Portal`

      previousPath.current = location.pathname

      setTimeout(() => {
        const mainContent = document.getElementById('main-content')
        if (mainContent) {
          mainContent.focus()
        }
      }, 100)
    }
  }, [location])

  return <>{children}</>
}

export const ScreenReaderOnly = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return (
    <Box
      component="span"
      className="sr-only"
      sx={{
        position: 'absolute',
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: 0,
      }}
    >
      {children}
    </Box>
  )
}
